import { api } from '@services';

interface IRequest {
  id: string;
  equipmentStatusId: string;
}

const updateDefaultStatus = async ({
  id,
  equipmentStatusId,
}: IRequest): Promise<void> => {
  await api.patch<string>(`/studios/${id}/defaultStatus`, {
    equipmentStatusId,
  });
};

export { updateDefaultStatus };
